import { render, staticRenderFns } from "./ISOAdd.vue?vue&type=template&id=19f020d4&"
import script from "./ISOAdd.vue?vue&type=script&lang=js&"
export * from "./ISOAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports